module.exports = __webpack_public_path__ + "img/dynatrace.31f0d380.png";